import React from 'react';
import { setCurrentView } from 'core/utils';
import { AssignCarrierServiceAndWarehouseViewStore } from 'modules/order/stores';
import { AssignCarrierServiceAndWarehouseTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new AssignCarrierServiceAndWarehouseViewStore(rootStore, componentProps),
	'assignCarrierServiceAndWarehouseViewStore'
)
class AssignCarrierServiceAndWarehouse extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <AssignCarrierServiceAndWarehouseTemplate {...this.props} />;
	}
}

export default AssignCarrierServiceAndWarehouse;



// WEBPACK FOOTER //
// ./src/modules/order/pages/AssignCarrierServiceAndWarehouse.jsx